import { render, staticRenderFns } from "./VCRDeletion.vue?vue&type=template&id=3d78d650&scoped=true&"
import script from "./VCRDeletion.vue?vue&type=script&lang=js&"
export * from "./VCRDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d78d650",
  null
  
)

export default component.exports